app.service('complaintHistory', function (modal, lazyLoad) {
	let $self, $tabs, $tabsContent;
	let activeTab = 0;
	let complaintsLoaded = false;

	function showComplaints() {

		if (complaintsLoaded) {
			setActiveTab();
			return false;
		}

		fetchComplaints().then(response => {
			fillTabs(response);
			setActiveTab();
			complaintsLoaded = true;
		}).fail(onError);
	}

	function handleShowReclamationsClick() {
		activeTab = $(this).index();

		showComplaints();
	}

	function handleShowReturnsClick() {
		activeTab = $(this).index();

		showComplaints();
	}

	function fetchComplaints() {
		return $.ajax({
			url: '/customer-all-complaints.ltr'
		});
	}

	function onError() {
		modal.alert("Błąd pobierania zakładki. Spróbuj ponownie za chwilę.");
	}

	function fillTabs(html) {
		$tabsContent.html(html).removeClass('loading');
	}

	function setActiveTab() {
		$tabs
			.removeClass('is-active')
			.eq(activeTab)
			.addClass('is-active');

		$tabsContent.find('.complaint-tab-content')
			.removeClass('is-active')
			.eq(activeTab)
			.addClass('is-active');

		lazyLoad.update();
	}

	function setEvents() {
		$self
			.on('click', '.js-show-reclamations', handleShowReclamationsClick)
			.on('click', '.js-show-returns', handleShowReturnsClick);
	}

	function setElements() {
		$self = $('.complaint-history');
		$tabs = $self.find('.complaint-tab');
		$tabsContent = $self.find('.complaint-tabs-content');
	}

	function init() {
		setElements();
		setEvents();
		showComplaints();
	}

	return {
		init
	};
});